import {observer} from 'mobx-react'
import {useStores} from '../../store'
import {ErrorComponent, FullLoader} from '../common'
import ListPageLayout from '../common/layout/ListPageLayout'
import {i18n}  from '../../i18n'
import React, {useState} from 'react'
import PraxisTable from './components/PraxisTable'
import EditPraxis from './components/EditPraxis'
import {usePagination} from '../../utils/hooks/usePagination'
import {TablePaginationConfig} from 'antd'
import {AnyObj, SearchDto} from '../../utils/types'
import {SearchComponentType} from '../../utils/enums'
import SearchComponent from '../common/SearchComponent'

const PraxisPage = observer(() => {
    const {praxisStore} = useStores()
    const [searchList, setSearchList] = useState<AnyObj>({})
    const [sortField, setSortField] = useState<string>()
    const [sortOrder, setSortOrder] = useState<string>()
    const [loading, paginationConfig] = usePagination(praxisStore, searchList, sortField, sortOrder)
    if (praxisStore.dataList === null) {
        return <FullLoader />
    }

    if (praxisStore.dataList === undefined) {
        return <ErrorComponent status={404} />
    }

    const searchParams: SearchDto[] = [
        {
            type: SearchComponentType.INPUT,
            searchParam: 'praxisName',
            placeholder: i18n.t('praxis.name')
        }
    ]

    const handleTableChange = (pagination: TablePaginationConfig, filters: any, sorter: any) => {
        setSortField(sorter.field)
        setSortOrder(sorter.order)
    }

    return (
        <ListPageLayout title={i18n.t('praxis.pageTitle')} modalWidth={'30%'} createModalTitle={i18n.t('praxis.create')} createModal={EditPraxis}>
            <SearchComponent searchParams={searchParams} onChangeFilter={setSearchList}/>
            <PraxisTable data={praxisStore.dataList} loading={loading} pagination={paginationConfig} onTableChange={handleTableChange} />
        </ListPageLayout>
    )
})

export default PraxisPage
